import { render, staticRenderFns } from "./b-ticket-additional-info.vue?vue&type=template&id=0438cf19&scoped=true"
import script from "./b-ticket-additional-info.vue?vue&type=script&lang=ts"
export * from "./b-ticket-additional-info.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-additional-info.vue?vue&type=style&index=0&id=0438cf19&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0438cf19",
  null
  
)

export default component.exports